import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'atlas-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalHeaderComponent {
  dialog = inject(MatDialogRef);
  hideCloseBtn = input<boolean>(false);

  close(): void {
    this.dialog.close();
  }
}
